const locale = {
  local: {
    key: "local",
    name: "Saxdor Turkey",
    multi_language: false,
    has_payment: false,
    culture: "de-DE",
    currency: "eur",
    symbol: "€",
    lang: "en",
    api: "http://localhost:9000",
    url: "http://localhost:3000",
    ai: "http://localhost:3001",
    dockApi: "http://localhost:8000/api",
    showPrice: true,
  },
  live: {
    key: "live",
    name: "Saxdor Turkey",
    multi_language: false,
    has_payment: false,
    culture: "de-DE",
    currency: "eur",
    symbol: "€",
    lang: "en",
    api: "https://api.saxdorturkey.com",
    url: "http://localhost:3000",
    ai: "http://localhost:3001",
    dockApi: "https://api.dock.saxdorturkey.com/api",
    showPrice: true,
  },
  sdturkey: {
    key: "sdturkey",
    name: "Saxdor Turkey",
    multi_language: true,
    has_payment: false,
    culture: "de-DE",
    currency: "eur",
    symbol: "€",
    lang: "en",
    api: "https://api.saxdorturkey.com",
    url: "https://configurator.saxdorturkey.com",
    ai: "https://api.ai.saxdorturkey.com",
    dockApi: "https://api.dock.saxdorturkey.com/api",
    showPrice: true,
  },
};

let { REACT_APP_LOCALE } = process.env;
if (!REACT_APP_LOCALE) REACT_APP_LOCALE = "local";

const selected_locale = locale[REACT_APP_LOCALE];

export const appConfig = {
  api: selected_locale.api,
  locale: selected_locale,
};
